import { TOGGLE_EMPLOYEE_TABLE } from "./employeeTableType" 

export const toggleEmployeeTable = (object:any) => {
    return {
        type: TOGGLE_EMPLOYEE_TABLE ,
        data: object
    }
}